export default __webpack_public_path__ + "static/media/ai0Kit.05c94b09.png";